"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocalStorageKey = void 0;
let LocalStorageKey = exports.LocalStorageKey = /*#__PURE__*/function (LocalStorageKey) {
  LocalStorageKey["Height"] = "height";
  LocalStorageKey["Visible"] = "visible";
  LocalStorageKey["Columns"] = "columns";
  LocalStorageKey["Density"] = "density";
  LocalStorageKey["ColumnVisibility"] = "column_visibility";
  LocalStorageKey["ColumnOrder"] = "column_order";
  return LocalStorageKey;
}({});